<template>
<div>
	<div v-title>资产定价</div>
	<div class="content">

	<headerIndex></headerIndex>

	<!-- 头部 -->
	<div class="header-box" style="display:none">
		<div class="homepage-header">
			<div class="header-logo l">
				<i class="main-logo"></i>
			</div>
			<div class="r">
				<ul class="header-text l">
					<router-link tag="li" :to="{path: '/homepage'}">
						<a href="#">首页</a>
					</router-link>
					<li><a href="#" @click="openLayer">产品服务</a></li>
					<router-link tag="li" :to="{path: '/antiFraud'}">
						<a href="#">反欺诈</a>
					</router-link>
					<router-link tag="li" :to="{path: '/assetsPricing'}">
						<a href="#">资产定价</a>
					</router-link>
					<li @click="openLayer"><a href="#">坏账揽收</a></li>
					<li @click="openLayer"><a href="#">资金供给</a></li>
				</ul>
				<p class="header-button l" style="margin-right:40px;">
					<span @click="openLayer"><a href="#">申请接入</a></span>
					<span @click="login"><a href="#">商家登录</a></span>
				</p>
			</div>
		</div>
	</div>

		<!-- 轮播banner图 -->
		<div class="swiper-container">
		    <div class="swiper-wrapper">
		        <div class="swiper-slide swiper-banner" :style="bannerStyle"></div>
		    </div>
		    <!-- 分页器 -->
		    <div class="swiper-pagination"></div>
		</div>

		<div class="assets-header" v-show="assetshouse">
			<ul class="assets-header-title">
				<li class="active" @click="houseClick"><span>房产订单</span></li>
				<li @click="carClick"><span>车产订单</span></li>
			</ul>
			<div class="assets-header-box">
				<ul class="assets-header-left l">
					<li style="height: 34px;">
						<span class="l">城市</span>
						<div class="city-text l">
							<p v-for="(item,index) in areaType" :data-id="item.area_id" @click="chooseCity(index,item.area_id,item.area_name)" :class="{ 'active': clickIndex == index}">{{item.area_name}}</p>
						</div>
					</li>
					<li>
						<span>小区名称</span>
						<div style="position:relative;display:inline-block">
							<input type="text" placeholder="请填写小区名称" v-model="Address" autocomplete="off" @keyup="searchAddress" @blur="closeAddress">
							<div class="el-cascader-menus el-popper" x-placement="bottom-start" style="position: absolute; top: 34px; left: 0px; z-index: 2161;" v-show="isAddress">
								<div class="popper__arrow" style="left: 35px;"></div>
								<ul class="el-cascader-menu">
									<li 
										class="el-cascader-menu__item el-cascader-menu__item--extensible" 
										v-for="item in addressArr"
										@click="chooseAddress(item.Id,item.Address,item.AreaCode,item.ProjectName,item.PropertyTypeId,item.ThreePropertyId)"
										>
										{{item.Address}}
									</li>
								</ul>
							</div>
						</div>

					</li>
					<li>
						<span>详细地址</span>
						<input type="text" placeholder="请填写详细地址" v-model="addressDetail">
					</li>
					<li>
						<span>所在楼层</span>
						<input type="text" placeholder="楼层（选填）" v-model="CurrentFloor" onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)" maxlength="4">
					</li>
					<li>
						<span>平米数</span>
						<input type="text" placeholder="房屋面积 如100.32" v-model="BuildArea" @keyup="formatMoneydd">
					</li>
					<li><p style="opacity:0.8;">所有商业银行指定的评估机构查询值</p></li>
				</ul>
				<div class="assets-header-right r">
					<div v-if="isErrorHouse" class="error-box">
						<p class="error-msg">{{errorMsg}}</p>
					</div>
					<ul>
						<li class="countdown-box">
							<input type="text" placeholder="请输入手机号" v-model="user_mobile" maxlength="11">
		                    <div class="countdown-wrap">
		                        <span class="countdown mobile-gettime" v-show="gettime">
		                            <em id="login-Countdown">{{countdownTime}}</em>秒后重发
		                        </span>
		                        <span class="countdown mobile-getyzm" v-show="getyzm" @click="timer(1)">
		                            {{yzmText}}
		                        </span>
		                    </div>
		                </li>
						<li><input type="text" placeholder="请输入您的手机验证码" maxlength="4" v-model="rightVerifyCode"></li>
					</ul>
					<p class="assets-header-btn" @click="assessHouse"><span>定价</span></p>
					<p class="assets-right-text">非登录用户免费查询2次/周</p>
				</div>
			</div>
		</div>
		<div class="assets-header" v-show="assetscar">
			<ul class="assets-header-title">
				<li @click="houseClick"><span>房产订单</span></li>
				<li class="active" @click="carClick"><span>车产订单</span></li>
			</ul>
			<div class="assets-header-box">
					<ul class="assets-header-left l">
						<li style="height: 34px;">
							<span class="l">城市</span>
							<div class="city-text l">
								<!-- <p class="active">北京</p>
								<label for="city"></label> -->
								<cityPicker 
									field="city" 
									placeholder="请选择城市" 
									:city-list="options" 
									:no-hot="true" 
									:value.sync="cityId">
								</cityPicker>
							</div>
						</li>
						<li>
							<span>车架号*</span>
							<input type="text" placeholder="请输入行驶证17位VIN码" v-model="carVin" maxlength="17" onkeyup="this.value=this.value.toUpperCase()">
						</li>
						<li style="position:relative;">
							<span>行驶里程*</span>
							<input type="text" placeholder="支持精度0.01" v-model="mileage" @keyup="formatMoney">
							<i class="input-text" style="position:absolute;top:8px;right:10px;">万公里</i>
						</li>
						<li class="data-picker-box">
							<span>登记日期*</span>
							<el-date-picker
								v-model="reg_date"
								type="month"
								placeholder="选择月"
								value-format="yyyy-MM">
							</el-date-picker>
						</li>
						<li><p style="opacity:0.8;">所有商业银行指定的评估机构查询值</p></li>
					</ul>
					<div class="assets-header-right r">
						<div v-if="isErrorCar" class="error-box">
							<p class="error-msg">{{errorMsg}}</p>
						</div>
						<ul>
							<li class="countdown-box">
								<input type="text" placeholder="请输入手机号" v-model="user_mobile" maxlength="11">
			                    <div class="countdown-wrap">
			                        <span class="countdown mobile-gettime" v-show="gettime">
			                            <em id="login-Countdown">{{countdownTime}}</em>秒后重发
			                        </span>
			                        <span class="countdown mobile-getyzm" v-show="getyzm" @click="timer(2)">
			                            {{yzmText}}
			                        </span>
			                    </div>
			                </li>
							<li><input type="text" placeholder="请输入您的手机验证码" maxlength="4" v-model="rightVerifyCode"></li>
						</ul>
						<p class="assets-header-btn" @click="assessCar"><span>定价</span></p>
						<p class="assets-right-text">非登录用户免费查询2次/周</p>
					</div>
				</div>
			</div>
		</div>

		<div class="assets-header">
			<div class="assets-result" v-if="isHouseResult">
				<div class="assets-result-top">
					<p class="f36 lh54">估值结果</p>
					<p class="lh41">估值结果仅供参考</p>
					<p class="f60 lh114">{{housePrice}}元</p>
				</div>
				<div class="assets-result-bottom">
					<ul class="l">
						<li>所在城市：{{area_name}}</li>
						<li>小区详细地址：{{addressDetail}}</li>
						<li>平米数：<span v-if="BuildArea">{{BuildArea}}</span><span v-else>--</span></li>
					</ul>
					<ul class="l">
						<li>小区名称：{{Address}}</li>
						<li>所在层数：{{CurrentFloor}}</li>
					</ul>
				</div>
			</div>
			<div class="assets-result" v-if="isCarResult">
				<div class="assets-result-top">
					<p class="f36 lh54">估值结果</p>
					<p class="lh41">估值结果仅供参考</p>
					<p class="f60 lh114">{{carPrice}}万</p>
				</div>
				<div class="assets-result-bottom">
					<ul class="l">
						<li>所在城市：北京</li>
						<li>车架号：{{carVin}}</li>
						<li>行驶里程：{{mileage}}万公里</li>
					</ul>
					<ul class="l">
						<li>登记日期：{{reg_date}}</li>
						<!-- <li>所在层数：1层</li> -->
					</ul>
				</div>
			</div>
		</div>

		<!-- 主体内容 -->
		<div class="assetsPricing">
			<!-- 主体内容一 -->
			<div class="assetsPrice-first">
				<p class="section-title pt86 pb20">定价、处置、市场风险透视 </p>
				<p class="section-word">车产定价有车300提供技术支持，房产定价有首佳、世联提供支持，你关心的，这里都有，超出你所想！ </p>
				<ul class="assets-first-box">
					<li class="assets-box-li active" @mouseover="animateAssets(0)">
						<p class="assets_1_1"></p>
						<p class="assets_1_2"></p>
						<p class="assets_1_text">
							<span><i>2000名+</i>车产估值人员</span>
							<span><i>2.392亿次</i>查询规模</span>
						</p>
					</li>
					<li class="assets-box-li" @mouseover="animateAssets(1)">
						<p class="assets_2_1"></p>
						<p class="assets_2_2"></p>
						<p class="assets_2_text">
							<span><i>2000名+</i>房产估值人员</span>
							<span><i>238个</i>房产覆盖城市</span>
							<span><i>2950万套</i>单套数量</span>
							<span><i>1832万次</i>查询规模</span>
						</p>
					</li>
				</ul>
			</div>

			<!-- 主体内容二  排行榜 -->
			<div class="assetsPrice-second bafafafa">
				<p class="section-title pt86 pb20">北京一周车系估值排行榜</p>
				<div class="assess-list-all">
					<!-- 左边排名 -->
					<ul class="assess-list l ml5">
						<li>
							<span class="list-num circle-bg">1</span>
							<span class="list-brand">哈弗H6</span>
							<span class="list-assess-num">估值次数<i>283</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num circle-bg">2</span>
							<span class="list-brand">哈弗H5</span>
							<span class="list-assess-num">估值次数<i>125</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num circle-bg">3</span>
							<span class="list-brand">奥迪A6L</span>
							<span class="list-assess-num">估值次数<i>104</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">4</span>
							<span class="list-brand">宝马3系</span>
							<span class="list-assess-num">估值次数<i>86</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">5</span>
							<span class="list-brand">宝来</span>
							<span class="list-assess-num">估值次数<i>86</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">6</span>
							<span class="list-brand">大切诺基(进口)</span>
							<span class="list-assess-num">估值次数<i>81</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">7</span>
							<span class="list-brand">宝马5系</span>
							<span class="list-assess-num">估值次数<i>80</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">8</span>
							<span class="list-brand">奥迪A4L</span>
							<span class="list-assess-num">估值次数<i>2915</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">9</span>
							<span class="list-brand">朗逸</span>
							<span class="list-assess-num">估值次数<i>75</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">10</span>
							<span class="list-brand">MINI(进口)</span>
							<span class="list-assess-num">估值次数<i>79</i></span>
							<span class="list-city">北京</span>
						</li>
					</ul>
					<!-- 右边排名 -->
					<ul class="assess-list r">
						<li>
							<span class="list-num">11</span>
							<span class="list-brand">帕萨特</span>
							<span class="list-assess-num">估值次数<i>68</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">12</span>
							<span class="list-brand">速腾</span>
							<span class="list-assess-num">估值次数<i>68</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">13</span>
							<span class="list-brand">凯美瑞</span>
							<span class="list-assess-num">估值次数<i>66</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">14</span>
							<span class="list-brand">迈腾</span>
							<span class="list-assess-num">估值次数<i>65</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">15</span>
							<span class="list-brand">奔驰E级</span>
							<span class="list-assess-num">估值次数<i>64</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">16</span>
							<span class="list-brand">奥迪A4L</span>
							<span class="list-assess-num">估值次数<i>62</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">17</span>
							<span class="list-brand">途观</span>
							<span class="list-assess-num">估值次数<i>58</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">18</span>
							<span class="list-brand">雅阁</span>
							<span class="list-assess-num">估值次数<i>57</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">19</span>
							<span class="list-brand">POLO</span>
							<span class="list-assess-num">估值次数<i>57</i></span>
							<span class="list-city">北京</span>
						</li>
						<li>
							<span class="list-num">20</span>
							<span class="list-brand">奥迪Q7(进口)</span>
							<span class="list-assess-num">估值次数<i>56</i></span>
							<span class="list-city">北京</span>
						</li>
					</ul>
				</div>
			</div>

			<!-- 主体内容三 -->
			<div class="assetsPrice-third">
				<p class="section-title pt86 pb20">快贷云 · 资产定价平台数据说明</p>
				<div class="volume-list-all">
					<h4>北京、上海、广州、深圳、青岛用度市场数据<i>[2017-10-09至2017-10-15]</i></h4>
					<ul class="volume-list l">
						<h4>北京<i>商品房</i>成交量价</h4>
						<li class="volume-list-title">
							<span class="administrative-region">行政区</span>
							<span class="house-type">物业类型</span>
							<span class="house-num">套数</span>
							<span class="house-acreage">面积(万m²)</span>
							<span class="average-price">均价(元/m²)</span>
						</li>
						<li>
							<span class="administrative-region">昌平区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">108</span>
							<span class="house-acreage">0.97</span>
							<span class="average-price">40840.00</span>
						</li>
						<li>
							<span class="administrative-region">平谷区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">123</span>
							<span class="house-acreage">0.85</span>
							<span class="average-price">15232.00</span>
						</li>
						<li>
							<span class="administrative-region">丰台区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">35</span>
							<span class="house-acreage">0.72</span>
							<span class="average-price">41435.00</span>
						</li>
						<li>
							<span class="administrative-region">开发区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">41</span>
							<span class="house-acreage">0.60</span>
							<span class="average-price">41028.00</span>
						</li>
						<li>
							<span class="administrative-region">通州区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">88</span>
							<span class="house-acreage">0.53</span>
							<span class="average-price">42894.00</span>
						</li>
						<li>
							<span class="administrative-region">大兴区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">89</span>
							<span class="house-acreage">0.50</span>
							<span class="average-price">27272.00</span>
						</li>
						<li>
							<span class="administrative-region">顺义区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">38</span>
							<span class="house-acreage">0.49</span>
							<span class="average-price">41128.00</span>
						</li>
						<li>
							<span class="administrative-region">海淀区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">88</span>
							<span class="house-acreage">0.44</span>
							<span class="average-price">29361.00</span>
						</li>
						<li>
							<span class="administrative-region">朝阳区</span>
							<span class="house-type">商品房</span>
							<span class="house-num">61</span>
							<span class="house-acreage">0.40</span>
							<span class="average-price">42382.00</span>
						</li>
						<li>
							<span class="administrative-region">密云县</span>
							<span class="house-type">商品房</span>
							<span class="house-num">30</span>
							<span class="house-acreage">0.38</span>
							<span class="average-price">24503.00</span>
						</li>
					</ul>
					<ul class="volume-list r">
						<h4>北京<i>住宅</i>成交量价</h4>
						<li class="volume-list-title">
							<span class="administrative-region">行政区</span>
							<span class="house-type">物业类型</span>
							<span class="house-num">套数</span>
							<span class="house-acreage">面积(万m²)</span>
							<span class="average-price">均价(元/m²)</span>
						</li>
						<li>
							<span class="administrative-region">平谷区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">112</span>
							<span class="house-acreage">0.81</span>
							<span class="average-price">15321.00</span>
						</li>
						<li>
							<span class="administrative-region">昌平区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">52</span>
							<span class="house-acreage">0.74</span>
							<span class="average-price">50295.00</span>
						</li>
						<li>
							<span class="administrative-region">顺义区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">15</span>
							<span class="house-acreage">0.40</span>
							<span class="average-price">48791.00</span>
						</li>
						<li>
							<span class="administrative-region">密云县</span>
							<span class="house-type">住宅</span>
							<span class="house-num">25</span>
							<span class="house-acreage">0.36</span>
							<span class="average-price">24953.00</span>
						</li>
						<li>
							<span class="administrative-region">通州区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">28</span>
							<span class="house-acreage">0.32</span>
							<span class="average-price">61206.00</span>
						</li>
						<li>
							<span class="administrative-region">延庆县</span>
							<span class="house-type">住宅</span>
							<span class="house-num">31</span>
							<span class="house-acreage">0.27</span>
							<span class="average-price">9757.00</span>
						</li>
						<li>
							<span class="administrative-region">房山区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">28</span>
							<span class="house-acreage">0.22</span>
							<span class="average-price">30822.00</span>
						</li>
						<li>
							<span class="administrative-region">大兴区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">12</span>
							<span class="house-acreage">0.20</span>
							<span class="average-price">53940.00</span>
						</li>
						<li>
							<span class="administrative-region">开发区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">14</span>
							<span class="house-acreage">0.20</span>
							<span class="average-price">47852.00</span>
						</li>
						<li>
							<span class="administrative-region">丰台区</span>
							<span class="house-type">住宅</span>
							<span class="house-num">12</span>
							<span class="house-acreage">0.17</span>
							<span class="average-price">81302.00</span>
						</li>
					</ul>
				</div>
			</div>

		</div>

		<div class="layer-box" v-show="isLayer">
			<div class="mask2"></div>
			<div class="layer">
				<h2 class="layer-title">请输入图形验证码</h2>
				<div class="layer-content">
		            <div class="layer-inputwraper">
		                <input type="text" placeholder="请输入图形中的字符" id="alertMsgCode" maxlength="4" v-model="img_code"/>
		                <img :src="img_url"  width="80" height="39" border="0" @click="changeImgSrc">
		            </div>
		            <p class="layer-error-msg">{{layerMsg}}</p>
	            </div>
	            <div class="layer-button">
	            	<p @click="closeLayer">取消</p>
	            	<p @click="imgLayerSure">确定</p>
	            </div>
			</div>
		</div>

		<footerIndex></footerIndex>


	</div>
</div>	
</template>

<script type="text/ecmascript-6">
	import '../../css/homepage.css'
	import '../../css/assetsPrice.css'
	import footerIndex from '../common/footerIndex.vue'
	import area from './area.json'
	import cityList from 'china-city-data'
	import cityPicker from './city-picker'
	import headerIndex from '../common/header.vue'

	window.CITY_PICKER_LIST = cityList;

	// console.log(cityList)

	export default{
		data(){
			return {
				bannerStyle:{
		            backgroundImage: "url(" + require("./images/bannerbg.jpg") + ")",
		            backgroundRepeat: "no-repeat",
		            backgroundSize: "auto 100%",
		            backgroundPosition: "center",
				},
				clickIndex:0,
	            value1:'',
				mileage:'',
				carVin:'',
				model_id:'',
				model_price:'',
				modelInfo:{},
				user_mobile:'',
				gettime:false,
				getyzm:true,
				isErrorCar:false,
				errorMsg:'123',
	            options:[],
	            value:'',
	            cityList,
	            cityId:'',
	            reg_date:'',
	            // 展示车房
	            assetshouse:true,
	            assetscar:false,
	            // 评房
      			homeAddType:[{"homeid":1,"homeName":"住宅","PropertyTypeId":"92"},{"homeid":2,"homeName":"商用","PropertyTypeId":"92"},{"homeid":3,"homeName":"别墅","PropertyTypeId":"92"},{"homeid":4,"homeName":"公寓","PropertyTypeId":"92"},{"homeid":5,"homeName":"商住","PropertyTypeId":"25"},{"homeid":6,"homeName":"办公","PropertyTypeId":"25"},{"homeid":8,"homeName":"底商","PropertyTypeId":"25"},{"homeid":7,"homeName":"其他","PropertyTypeId":"25"}],
      			// 模糊查询小区所需城市id
      			areaType:[{'area_id':110100,'area_name':'北京'},{'area_id':310100,'area_name':'上海'},{'area_id':120100,'area_name':'天津'}],
      			area_id:'110100',
      			area_name:'北京',
      			PropertyType:'92',  /*选择二级物业ID,没有入口,暂时写成92,详见homeAddType*/
      			Address:'',
      			addressArr:[],
      			isAddress:false,
      			addressDetail:'',
      			BuildArea:'',
      			CurrentFloor:'',
      			AddressId:'',
      			Area_code:'',
      			ProjectName:'',
      			ThirdProperty:'',
      			isErrorHouse:false,
      			// 验证码
      			img_code:'',
				countdownTime:'',
				yzmText:'获取验证码',
				isLayer:'',
	            layerMsg: '',
	            csrfToken:'',
	            img_url:'',
	            rightVerifyCode:'',
	            isError:'',
	            isHouseResult:false,
	            isCarResult:false,
	            carPrice:'',
	            housePrice:'',
	            isAssessCar: true,
	            isAssessHouse: true,


			}
		},
		components: {
			footerIndex,
			cityPicker,
			headerIndex
		},
		methods:{
			animateAssets,
			assessCar,
			timer,
			getData,
			formatMoney,
			houseClick,
			carClick,
			// 评房
			chooseCity,
			searchAddress,
			chooseAddress,
			closeAddress,
			assessHouse,
			formatMoneydd,
			// 验证码
			changeImgSrc,
			closeLayer,
			imgLayerSure,
			openLayer,
			login

		},
		mounted(){
			this.getData();
		}
	}

	function login(){
		// location.href = 'http://admin.test.senqiang.cn';
		location.href = this.$store.state.adminUrl;
	}



	// 评房选择城市
	function chooseCity(index,area_id,area_name){
		this.clickIndex = index;
		this.area_id = area_id;
		this.area_name = area_name;
	}

	// 评房查询小区
	function searchAddress(){
		this.$http.post(this.$store.state.apiUrl+'/assess/getSearchResidence',{},{
			params:{
				'AreaCode': this.area_id,
				'PropertyType': this.PropertyType,
				'Address': this.Address,
				'reg_date': this.reg_date,
				'PageIndex': 1,
				'PageSize': 10,
				'from': 1
			}
		}).then((response) => {
			response = response.body;
			console.log(response)
			if(response.code == 0){
				this.addressArr = [];
				for (var i in response.data) {
				    this.addressArr.push(response.data[i]); 
				}	
				this.isAddress = true;		
			}
			
		})
	}

	// 评房选择小区
	function chooseAddress(Id,Address,AreaCode,ProjectName,PropertyTypeId,ThreePropertyId){
		this.Address = Address;
		this.AddressId = Id;
		this.Area_code = AreaCode;
		this.ProjectName = ProjectName;
		this.ThirdProperty = ThreePropertyId;
		this.PropertyType = PropertyTypeId;
		var _this = this;
		setTimeout(function() {
			_this.isAddress = false;
		}, 300);
	}

	function closeAddress(){
		var _this = this;
		setTimeout(function() {
			_this.isAddress = false;
		}, 300);
	}

	// 评房
	function assessHouse(){
		if(this.area_id == ''){
			this.isErrorHouse = true;
			this.errorMsg = '请选择城市';
		}else if(this.Area_code == ''){
			this.isErrorHouse = true;
			this.errorMsg = '请填写正确的小区地址';
		}else if(this.addressDetail == ''){
			this.isErrorHouse = true;
			this.errorMsg = '请填写详细地址';
		}else if(this.BuildArea == ''){
			this.isErrorHouse = true;
			this.errorMsg = '请填写平米数';
		}else if(this.user_mobile == ''){
			this.isErrorHouse = true;
			this.errorMsg = '请填写手机号';
		}else{
			if(this.isAssessHouse){
				this.isAssessHouse = false;
		        this.$http.get(this.$store.state.apiUrl+'/share/verifySmsCode?phone='+this.user_mobile+'&code='+this.rightVerifyCode).then((response) => {
		            response = response.body;
		            console.log(response)
		            this.isAssessHouse = true;
		            if(response.code == 0){
						this.$http.post(this.$store.state.apiUrl+'/assess/saasHouseAssessAuto',{},{
							params:{
								'check_user_phone':this.user_mobile,
								'AddressId': this.AddressId,
								'Area_code': this.Area_code,
								'ProjectName': this.ProjectName,
								'ThirdProperty': this.ThirdProperty,
								'PropertyType': this.PropertyType,
								'Address': this.Address,
								'CurrentFloor': this.CurrentFloor,
								'BuildArea': this.BuildArea,
							}
						}).then((response) => {
							console.log(response)
							response = response.body;
							if(response.code == 0){
								console.log('估值成功')
								this.assetshouse = false;
								this.assetscar = false;
								this.housePrice = response.data.TotalPrice;
								this.isHouseResult = true;
							}else if(response.data == 'false'){
								this.isErrorHouse = true;
		            			this.errorMsg = response.message;
							}else{
								this.isErrorHouse = true;
		            			this.errorMsg = response.message;
							}
						})
		            }else{
		            	this.isErrorHouse = true;
		            	this.errorMsg = response.message;
		            }
		        })
	        }
		}
	}


	function formatMoney(){
        this.mileage = this.mileage.replace(/^\d{7}\.\d{2}$/g,"");
        this.mileage = this.mileage.replace(/\.{2,}/g,".");
        this.mileage = this.mileage.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        this.mileage = this.mileage.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');

        if(this.mileage.indexOf(".") < 0 && this.mileage.length > 2){
          this.mileage = this.mileage.substring(0,2);
        }
	}

	function formatMoneydd(){
        this.BuildArea = this.BuildArea.replace(/^\d{4}\.\d{2}$/g,this.BuildArea);
        this.BuildArea = this.BuildArea.replace(/\.{2,}/g,".");
        this.BuildArea = this.BuildArea.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        this.BuildArea = this.BuildArea.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
        if(this.BuildArea.indexOf(".") < 0 && this.BuildArea.length > 4){
        	this.BuildArea = this.BuildArea.substring(0,4);
        }
	}

	function getData(){
		this.options = area;
	}

	function houseClick(){
		this.assetshouse = true;
		this.assetscar = false;
	}
	function carClick(){
		this.assetshouse = false;
		this.assetscar = true;
	}


	function assessCar(){
		// console.log(this.cardata.modelInfo.model_price)
		if(this.isAssessCar){
			this.isAssessCar = false;

			if(this.carVin == ''){
				this.isErrorCar = true;
				this.isAssessCar = true;
				this.errorMsg = '请填写车架号';
			}else if(this.mileage == ''){
				this.isErrorCar = true;
				this.isAssessCar = true;
				this.errorMsg = '请填写行驶里程';
			}else if(this.reg_date == ''){
				this.isErrorCar = true;
				this.isAssessCar = true;
				this.errorMsg = '请选择登记日期';
			}else if(this.user_mobile == ''){
				this.isErrorCar = true;
				this.isAssessCar = true;
				this.errorMsg = '请填写手机号';
			}else{
		        this.$http.get(this.$store.state.apiUrl+'/share/verifySmsCode?phone='+this.user_mobile+'&code='+this.rightVerifyCode).then((response) => {
		            response = response.body;
		            console.log(response)
		            if(response.code == 0){
						var carVin = (this.carVin).toUpperCase();
						this.$http.post(this.$store.state.apiUrl+'/assess/getCarInfoByVin',{},{
							params:{
								'vin': carVin,
								'from': 1,
							}
						}).then((response) => {
							console.log(response)
							response = response.body;
							if(response.code == 0){
								this.model_id = response.data.model_id;
								this.$http.post(this.$store.state.apiUrl+'/assess/saasAssessCarAuto',{},{
									params:{
										/*'check_user_phone': '17600113379',
										'model_id': '22811',
										'zone': '11',
										'reg_date': '2012-3',
										'mile': '4'*/
										'check_user_phone': this.user_mobile,
										'model_id': this.model_id,
										'zone': this.cityId,
										'reg_date': this.reg_date,
										'mile': this.mileage
									}
								}).then((response) => {
									console.log(response)
									response = response.body;
									if(response.code == 0){
										this.isAssessCar = true;
										this.carPrice = response.data.modelInfo.model_price;
										this.assetshouse = false;
										this.assetscar = false;
										this.isCarResult = true;
										// this.model_price = this.modelInfo.model_price;
									}else{
						            	this.isErrorCar = true;
						            	this.isAssessCar = true;
						            	this.errorMsg = response.message;
									}
								})

							}else{
				            	this.isErrorCar = true;
				            	this.isAssessCar = true;
				            	this.errorMsg = response.message;
							}
						})
		            }else{
		            	this.isErrorCar = true;
		            	this.isAssessCar = true;
		            	this.errorMsg = response.message;
		            }
		        })


			}

		}
	}


	function animateAssets(num){
		var animateArr = document.getElementsByClassName("assets-box-li");
		for(var i = 0; i<animateArr.length;i++){
			if( i == num){
				animateArr[i].classList.add("active");
			}else{
				animateArr[i].classList.remove("active");
			}
		}
	}

	//倒计时
	let timers=59;
	let timer1;
	function timer(num){ 
		if(this.user_mobile == ''){
			if(num == 1){
				this.isErrorHouse = true;
			}else if(num == 2){
				this.isErrorCar = true;
			}
			this.errorMsg = '请填写手机号';
			return false;
		}
	    //获取短信验证码
	    this.$http.get(this.$store.state.apiUrl+'/share/sms?phone='+this.user_mobile).then((response) => {
	        response = response.body;
	        console.log(response)
	        if(response.code == 0){
	            let _this = this;
	        	_this.isError = false;
				if(num == 1){
					_this.isErrorHouse = false;
				}else if(num == 2){
					_this.isErrorCar = false;
				}
	            _this.gettime = true;
	            _this.getyzm = false;
	            timer1 = setInterval(function(){
	                if(timers<10){
	                    _this.countdownTime = "0"+ timers--;
	                }else{
	                    _this.countdownTime = timers--;
	                }
	                if(timers==-1){
	                    _this.countdownTime = 60;
	                    _this.gettime = false;
	                    _this.getyzm = true;
	                    _this.yzmText = "重新获取";
	                    timers=59;
	                    clearInterval(timer1);
	                } 
	            },1000);
	        }else if(response.code == 2066){
	        	this.isError = false;
				if(num == 1){
					this.isErrorHouse = false;
				}else if(num == 2){
					this.isErrorCar = false;
				}	        	
	            this.isLayer = true;
	            this.layerMsg = '';
	            this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	                response = response.body;
	                if(response.code == 0){
	                    this.csrfToken = response.data;
	                    this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	                }else{
	                    console.log('请求失败')
	                }
	            })
	        }else if(response.code == 2061){
	        	this.isError = true;
				if(num == 1){
					this.isErrorHouse = true;
				}else if(num == 2){
					this.isErrorCar = true;
				}	        	
	        	this.errorMsg = '您获取短信验证码过于频繁，请明天再试';
	        }else{
	        	this.isError = true;
				if(num == 1){
					this.isErrorHouse = true;
				}else if(num == 2){
					this.isErrorCar = true;
				}	        	
	        	this.errorMsg = response.message;
	        	console.log(response.message)
	        }
	    })
	}

	// 改变图形验证码
	function changeImgSrc(){
	    this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	        response = response.body;
	        if(response.code == 0){
	            this.csrfToken = response.data;
	            this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	        }else{
	            console.log('请求失败')
	        }
	    })
	}

	// 关闭弹框
	function closeLayer(){
		this.isLayer = false;
	}
	//图形验证码确认
	function imgLayerSure(){
	    if(this.img_code == ''){
	        this.layerMsg='图形验证码不能为空';
	        return false;
	    }
	    this.$http.get(this.$store.state.apiUrl+'/share/sms',{
	        params:{
	            image:this.img_code,
	            phone: this.user_mobile,
	            key: this.csrfToken,
	        }
	    }).then((response) => {
	        response = response.body;
	        console.log(response);
	        if(response.code == 0){
	            this.isLayer = false;
	            let _this = this;
	            _this.gettime = true;
	            _this.getyzm = false;
	            timer1 = setInterval(function(){
	                if(timers<10){
	                    _this.countdownTime = "0"+ timers--;
	                }else{
	                    _this.countdownTime = timers--;
	                }
	                if(timers==-1){
	                    _this.countdownTime = 60;
	                    _this.gettime = false;
	                    _this.getyzm = true;
	                    _this.yzmText = "重新获取";
	                    timers=59;
	                    clearInterval(timer1);
	                } 
	            },1000);
	        }else if(response.code==2067){
	            this.layerMsg='图形验证码有误';
	            this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	                response = response.body;
	                if(response.code == 0){
	                    this.csrfToken = response.data;
	                    this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	                }else{
	                    console.log('请求失败')
	                }
	            })
	            return false;
	        }
	    })
	}

	function openLayer(){
		this.$message({
			showClose: true,
			message: '正在努力开发中,敬请期待',
			type: 'success'
		});
	}

</script>
<style>
	.data-picker-box .el-input__prefix{
		width: 25px !important;
		color: #c0c4cc !important;
	}
	.data-picker-box .el-input__suffix{
		width: 0 !important;
	}
	.data-picker-box .el-input__suffix .el-input__suffix-inner{
	    width: 18px !important;
	    color: #444 !important;
	}
	.data-picker-box .el-input__icon {
	    width: 25px !important;
	    line-height: 32px;
	}
	.data-picker-box .el-date-editor.el-input, .el-date-editor.el-input__inner{
		width: 324px !important;
	}
	.el-input__inner::-webkit-input-placeholder{
	    color: #444;
	}
	.data-picker-box .el-input__inner{
		width: 100%;
		border-radius: 0;
	}
	.countdown-box{
		position: relative;
	}
	.countdown-wrap{
		position: absolute;
		right: 0;
		top: 0;
	} 
	.countdown-wrap .countdown{
        width: 100%;
        font-size: 16px;
        color: #fff;
        text-align: center;
        height: 34px;
        line-height: 34px;
        background: #0ea3f0;
        border-radius: 0.08rem;
        display: inline-block;
        cursor: pointer;
    }
    .countdown-wrap .mobile-gettime{
    	background: #ccc;
    }

    .credit-detail{
    	width: 70%;
    	height: 80%;
    	position: fixed;
    	top: 100px;
    	left: 15%;
    	background: #fff;
    	z-index: 999;
    	padding: 0 50px;
    	padding-top: 50px;
    	overflow-y: scroll;
    }
    .credit-detail table{
    	width: 100%;
    	text-align: center;
    	border: 1px solid #ccc;
    	color: #797979;
    	font-size: 14px;
    	margin-bottom: 20px;
    }
    .credit-detail table tr {
	    height: 38px;
	    line-height: 38px;
	}
	.credit-detail h2{
	    color: #444444;
	    font-size: 16px;
	    height: 42px;
	    line-height: 42px;
	    border-bottom: 1px solid #dedede;
	}
	.organType{
		width: 24px;
		height: 24px;
	}
	.organType img{
		width: auto;
		height: 24px;
		vertical-align: middle;
	}
	.credit-detail-part{
		/*background: #eee;*/
		margin-bottom: 20px;
		padding-left: 20px;
		font-size: 16px;
		line-height: 36px;
	}
	.credit-part2{
		border-bottom: 1px dashed #dedede;
	}
	.credit-detail-part dt{
		color: #898989;
		display: inline-block;
	}
	.credit-detail-part dd{
		display: inline-block;
	}
	.closeIcon{
		width: 100%;
		display: inline-block;
		text-align: right;
	}
	.assets-header-left .error-msg {
	    color: red;
	    font-size: 16px;
	    padding-left: 154px;
	    margin-left: 0;
	}
	.assets-header-box .el-cascader-menu__item{
		width: 304px;
		height: auto;
		white-space: normal;
	}
	.assets-header-right{
		position: relative;
	}
	.error-box{
		position: absolute;
		top: 45px;
		left: 0;
	    width: 312px;
	    height: 34px;
	}
	.error-box .error-msg{
		padding-left: 123px;
	}
</style>


// WEBPACK FOOTER //
// src/components/homepageComponent/assetsPricing.vue